var _rect, _rect2, _path, _rect3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#F1F5F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 22,
    height: 10,
    rx: 3,
    fill: "#0A8CE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4891 27H9.23906V26.2148L11.9773 22.2891H9.31328V21.2891H13.4148V22.0703L10.6805 26H13.4891V27ZM15.1992 27V21.2891H16.4102V27H15.1992ZM20.4719 21.2891C21.2089 21.2891 21.7466 21.4479 22.0852 21.7656C22.4237 22.0807 22.593 22.5156 22.593 23.0703C22.593 23.3203 22.5552 23.5599 22.4797 23.7891C22.4042 24.0156 22.2805 24.2174 22.1086 24.3945C21.9393 24.5716 21.7128 24.7122 21.4289 24.8164C21.1451 24.918 20.7948 24.9688 20.3781 24.9688H19.8586V27H18.6477V21.2891H20.4719ZM20.4094 22.2812H19.8586V23.9766H20.257C20.4836 23.9766 20.6802 23.9466 20.8469 23.8867C21.0135 23.8268 21.1424 23.7331 21.2336 23.6055C21.3247 23.4779 21.3703 23.3138 21.3703 23.1133C21.3703 22.832 21.2922 22.6237 21.1359 22.4883C20.9797 22.3503 20.7375 22.2812 20.4094 22.2812Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 4.5,
    width: 15,
    height: 10,
    rx: 1.5,
    stroke: "#59709B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.157 6H13V13H18.3529V8.18565L16.157 6ZM16.2941 6.71729L17.6418 8.05882H16.2941V6.71729ZM13.4118 12.5882V6.41176H14.6471V6.82353H15.0588V6.41176H15.8824V8.47059H17.9412V12.5882H13.4118ZM14.2353 9.29412H14.6471V9.70588H14.2353V9.29412ZM14.6471 9.29412V8.88235H15.0588V9.29412H14.6471ZM14.6471 8.47059V8.05882H15.0588V8.47059H14.6471ZM14.2353 8.47059H14.6471V8.88235H14.2353V8.47059ZM14.2353 7.64706H14.6471V8.05882H14.2353V7.64706ZM14.6471 7.64706V7.23529H15.0588V7.64706H14.6471ZM14.2353 6.82353H14.6471V7.23529H14.2353V6.82353ZM14.6471 9.86606C14.1929 9.86606 13.8235 10.2354 13.8235 10.6896C13.8235 11.1438 14.1929 11.5131 14.6471 11.5131C14.6726 11.5131 14.6969 11.5102 14.7372 11.5049C15.0032 11.4756 15.2388 11.3175 15.3676 11.0824C15.436 10.9576 15.4706 10.8255 15.4706 10.6896C15.4706 10.2354 15.1012 9.86606 14.6471 9.86606ZM15.0065 10.8852C14.9423 11.0025 14.8249 11.0816 14.6928 11.096L14.6466 11.1018C14.4198 11.1018 14.2353 10.9169 14.2353 10.69C14.2353 10.4631 14.4202 10.2782 14.6471 10.2782C14.8739 10.2782 15.0588 10.4631 15.0588 10.69C15.0588 10.7555 15.0411 10.8214 15.0065 10.8852Z",
    fill: "#59709B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcZip);
export default __webpack_public_path__ + "static/media/ic-zip.cd702702ee70d119fc1fe82c36745bfd.svg";
export { ForwardRef as ReactComponent };